export default {"src":"/_next/static/media/step-1.639a4357.svg","height":455,"width":488,"blurWidth":0,"blurHeight":0};